module.exports = __webpack_public_path__ + "static/media/portfolio (22).b285b8d2.jpg";